var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.12 149.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6e45;}.cls-2{fill:#07586b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.06,72.52h0a2.38,2.38,0,0,1,.7,1.69,2.41,2.41,0,0,1-4.11,1.71L87.77,61a2.41,2.41,0,1,1,3.4-3.4Zm14.3,14.31h0a2.4,2.4,0,0,1-3.4,3.4l-6.41-6.42a2.4,2.4,0,0,1,0-3.4,2.38,2.38,0,0,1,3.39,0ZM88.24,109.12l13.68,13.68h0a15.07,15.07,0,1,0,21.32-21.31L79.94,58.19A15.08,15.08,0,0,0,54.28,68.31l-10-10a27.17,27.17,0,0,1,44.24-8.69l43.29,43.29A27.21,27.21,0,1,1,93.34,131.4L71.75,109.7a31.82,31.82,0,0,0,16.49-.58Zm19.4-16.44,12.19,12.19h0A10.26,10.26,0,1,1,105.4,119.3L93.2,107.11h0a31.86,31.86,0,0,0,14.52-14.43ZM86.35,71.36A10.26,10.26,0,0,1,71.84,85.79h-.12L62.1,76.07A10.25,10.25,0,1,1,76.54,61.64ZM28.43,42.49A10.26,10.26,0,1,1,42.94,28.06L55.13,40.23h0A32.08,32.08,0,0,0,40.6,54.76ZM8.51,35.23A27.17,27.17,0,0,1,54.89,16L76.53,37.68A32.85,32.85,0,0,0,60,38.23L46.34,24.58A15.07,15.07,0,1,0,25,45.89L68.45,89.33A15.06,15.06,0,0,0,94,79.07L104,89A27.28,27.28,0,0,1,88.1,104.05a28,28,0,0,1-10.68,1.61A27.11,27.11,0,0,1,60,98L16.49,54.44a27,27,0,0,1-8-19.21ZM112.56,144.08a32,32,0,0,0,22.62-54.56L58.29,12.63a32,32,0,1,0-45.2,45.21l43.29,43.29.26.24L90,134.72a31.82,31.82,0,0,0,22.59,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116,35.51a2.4,2.4,0,0,1-1.7-4.1l9.62-9.62a2.41,2.41,0,0,1,3.4,3.4l-9.62,9.62a2.36,2.36,0,0,1-1.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.54,128a2.41,2.41,0,0,1-1.7-.71,2.38,2.38,0,0,1,0-3.39l9.62-9.62a2.37,2.37,0,0,1,1.72-.77,2.41,2.41,0,0,1,1.74.7,2.46,2.46,0,0,1,.71,1.74,2.38,2.38,0,0,1-.77,1.72l-9.62,9.62a2.41,2.41,0,0,1-1.7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.56,130.78h0a2.4,2.4,0,0,1,2.41,2.4v13.54a2.41,2.41,0,0,1-4.81,0V133.18a2.39,2.39,0,0,1,2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.56,18.35a2.4,2.4,0,0,1-2.4-2.41V2.41a2.41,2.41,0,1,1,4.81,0V15.94A2.41,2.41,0,0,1,74.56,18.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.12,74.56a2.4,2.4,0,0,1-2.4,2.41H133.18a2.41,2.41,0,0,1,0-4.81h13.54A2.39,2.39,0,0,1,149.12,74.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.41,77a2.41,2.41,0,1,1,0-4.81H15.94a2.41,2.41,0,1,1,0,4.81Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalAttachment);
export default __webpack_public_path__ + "static/media/ModalAttachment.9626c5f4.svg";
export { ForwardRef as ReactComponent };